import { getLocalizedMessage } from "../UtilityFunctions/utils";
import { createAction } from "../containers/AuditListingContainer/AuditListingColumns";

export const EMAIL_REGEX =
  /^([0-9a-zA-Z]+['\-._+]?)+[0-9a-zA-Z]+[@]([0-9a-zA-Z]+[-]?){2,}[.](([a-zA-Z]+[-]?){2,}[.]){0,2}[a-zA-Z]{2,}$/; // NOSONAR

export const numberRegex = /^\d*(\.\d*)?$/;
export const WHITE_SPACES_REGEX = /^(\S+$)/g;
export const MOBILE_NUMBER_REGEX = /^\d{6,14}$/;
export const ALPHA_NUMERIC_REGEX = /^[a-zA-Z0-9]*$/;

export const PASSWORD_REGEX_WITH_SPECIAL_CHARACTERS =
  /^(?=.*[a-z])(?=.*[A-Z])(?=.*\d)(?=.*[!@#$%^&*])(?=.{0,20}$)/; // NOSONAR

export const PUBLIC_API_ROUTES = {
  LOGIN: "/api/public/login",
  RESEND_OTP: "/api/resend/otp",
  VERIFY_OTP: "/api/verify/otp",
  LOG_OUT: "/api/logout",
  FORGOT_PASSWORD: "/api/public/forgot-password",
  RESET_PASSWORD: "/api/public/reset-password",
  CONVERSATION_TOKEN: "/api/conversationsid",
};

export const PRIVATE_API_ROUTES = {
  DASHBOARD: "/api/dashboard",
  TOTAL_AUDIT_VS_COMPLETE_AUDIT:
    "/api/dashboards/total-audit-vs-complete-audit",
  GRADING_GRAPH: "/api/dashboards/grade-count",
  COUNT_LEVEL: "/api/dashboards/questionnaire-question-count-level",
  DOWNLOAD_DASHBOARD_REPORT: "/api/dashboards/report",
  COUNTRY: "/api/country",
  PRODUCT_CATEGORY: "/api/product-category",
  PRODUCT_CATEGORY_LISTING: "/api/product-category",
  CHANGE_PASSWORD: "/api/change-password",
  CHANGE_USER_PASSWORD: "/api/change-user-password",
  USER_SETTINGS: "/api/users/notification/setting",
  PRODUCT_SUBCATEGORY: "/api/sub-product-category",
  USER_LISTING: "/api/users",
  USER_BLOCK_UNBLOCK: (userId) => `/api/users/${userId}/active`,
  ALL_ROLES: "/api/roles",
  CREATE_USER: "/api/users",
  UPLOAD_MEDIA: "/api/file",
  USER_BY_ID: (userId) => `/api/users/${userId}`,
  QUESTIONNAIRE_LISTING: "/api/questionnaires",
  CHECK_QUESTIONNAIRE: "/api/check/questionnaires",
  QUESTIONNAIRE: "/api/questionnaires",
  AUDIT_LIST: "/api/audit",
  TM_LIST: "/api/tm-list",
  DNSD_LIST: "/api/dnsd-list",
  PRODUCT_AND_SUB_CATEGORY_LIST: "/api/product-category",
  PLAN_AUDIT: "/api/plan-audit",
  ASSIGN_SUB_PRODUCT_TO_QUESTIONNAIRE: "/api/assigned/product-sub-category",
  QUESTIONNAIRE_BY_ID: (questionnaireCode) =>
    `/api/questionnaires/${questionnaireCode}`,
  PRODUCT_SUB_CATEGORY: "/api/product-sub-category",
  GET_COUNTRIES_FOR_QUESTIONNAIRE: "/api/country/questionnaire",
  COUNTRY_QUESTIONNAIRE: "/api/questionnaires/specific-country",
  DOWNLOAD_USER_REPORTS: "/api/report/users",
  DOWNLOAD_PRODUCT_REPORTS: "/api/report/product-category",
  DOWNLOAD_AUDIT_REPORTS: "/api/report/audits",
  DOWNLOAD_QUESTIONNAIRE_REPORTS: "/api/report/questionnaires",
  SET_AUDIT_MEDIUM: (auditId) => `/api/audit/medium/${auditId}`,
  UPDATE_AUDIT_STATUS: (auditId) => `/api/audit/${auditId}`,
  AUDIT_QUESTIONNAIRE_BY_ID: "/api/audit/questionnaire",
  AUDIT_PREVIEW: "/api/audit/preview",
  SAVE_QUESTION_RESPONSE: "/api/questionnaires/question/response",
  SEND_LINK_TO_DNSD: (auditId) => `/api/audit/link/${auditId}`,
  SEND_REPORT: (auditId) => `/api/audit/send-report/${auditId}`,
  UPDATE_AUDIT_TM: (auditId) => `/api/audit/tm/${auditId}`,
  JOIN_REMOTE_CALL_TM: (id) => `/api/rooms/${id}`,
  JOIN_REMOTE_CALL: `/api/join-room`,
  CHECK_PARTICIPANT: `/api/check-participant`,
  SWITCH_PROFILE: (roleId) => `/api/token/${roleId}`,
  GET_NOTIFICATIONS_LIST: "/api/notification",
  ROOM_REQUEST: "/api/rooms/request",
  RECORDING_EVIDENCE: "/api/rooms/recording",
  UPDATE_FLAGS: `/api/video`,
  MARK_NOTIFICATION_READ: "/api/notification/read",
  UPLOAD_MEDIA_MULTIPART: "/api/file/multipart",
};

export const RESEND_OTP_INPUT_TIMER = 20;
export const RESEND_OTP_INPUT_LIMIT_EXCEED_TIMER = 900;
export const PAGE_LIMIT = 10;
export const PASSWORD_MAX_LIMIT = 20;
export const PASSWORD_MIN_LIMIT = 8;

export const criterias = [
  { pattern: /^.{8,20}$/, message: "At least 8 character(s)" },
  { pattern: /\d+/, message: "At least 1 numeric character(s)" },
  { pattern: /[A-Z]+/, message: "At least 1 upper case character(s)" },
  { pattern: /[a-z]+/, message: "At least 1 lower case character(s)" },
  {
    pattern: /[*.!@#$^&_+-]+/,
    message: "At least 1 of the following: !?.@#$%^&",
  },
];

export const recordsPerPageOptions = [10, 20, 50, 100];

export const userRole = {
  ADMIN: 1,
  CA: 2,
  TM: 3,
  DNSD: 4,
};

export const QUICK_LINKS = (intl) => [
  {
    title: getLocalizedMessage(intl, "dashboard.popup.listHeadingDashboard"),
    icon: "/icons/Dash.svg",
    description: getLocalizedMessage(intl, "dashboard.popup.listDescription"),
    allowedAccess: [userRole.ADMIN, userRole.CA, userRole.TM],
    route: "/",
    filledIcon: "/icons/DashFilled.svg",
  },
  {
    title: getLocalizedMessage(
      intl,
      "dashboard.popup.listHeadingUserManagement"
    ),
    icon: "/icons/user_management.svg",
    description: getLocalizedMessage(intl, "dashboard.popup.listDescription"),
    allowedAccess: [userRole.ADMIN, userRole.CA],
    route: "/users",
    filledIcon: "/icons/usermanagementFilled.svg",
  },
  {
    title: getLocalizedMessage(
      intl,
      "dashboard.popup.listHeadingManageProductCategories"
    ),
    icon: "/icons/manageProductCategories.svg",
    description: getLocalizedMessage(intl, "dashboard.popup.listDescription"),
    allowedAccess: [userRole.ADMIN, userRole.CA],
    route: "/product-category",
    filledIcon: "/icons/manageProductCategoriesFilled.svg",
  },
  {
    title: getLocalizedMessage(
      intl,
      "dashboard.popup.listHeadingManageAuditsQuestion"
    ),
    icon: "/icons/manageAuditQuestion.svg",
    description: getLocalizedMessage(intl, "dashboard.popup.listDescription"),
    allowedAccess: [userRole.ADMIN, userRole.CA],
    route: "/questionnaire",
    filledIcon: "/icons/manageAuditQuestionFilled.svg",
  },
  {
    title: getLocalizedMessage(intl, "dashboard.popup.listHeadingManageAudits"),
    icon: "/icons/manageAudit.svg",
    description: getLocalizedMessage(intl, "dashboard.popup.listDescription"),
    allowedAccess: [userRole.ADMIN, userRole.CA, userRole.TM],
    route: "/audit-listing",
    filledIcon: "/icons/manageAuditFilled.svg",
  },
];

export const questionnaireTypeOptions = [
  { value: 1, label: "Operational" },
  { value: 2, label: "Repair" },
];

export const QUESTION_TYPE_CONSTANTS = {
  SINGLE_SELECT: "single_select",
  MULTI_SELECT: "multi_select",
  TEXTBOX: "textbox",
};

export const questionnaireSelectOptions = [
  {
    value: QUESTION_TYPE_CONSTANTS.SINGLE_SELECT,
    label: "Single select",
  },
  {
    value: QUESTION_TYPE_CONSTANTS.MULTI_SELECT,
    label: "Multiple Select",
  },
  {
    value: QUESTION_TYPE_CONSTANTS.TEXTBOX,
    label: "Textbox",
  },
];

export const QUESTIONNAIRE_TYPE_FILTER_OPTIONS = [
  {
    id: "is_operational_audit",
    name: "is_operational_audit",
    fullName: "Operational",
  },
  { id: "is_repair_audit", name: "is_repair_audit", fullName: "Repair" },
];

export const plannedMonth = [
  { name: "January", value: 1 },
  { name: "February", value: 2 },
  { name: "March", value: 3 },
  { name: "April", value: 4 },
  { name: "May", value: 5 },
  { name: "June", value: 6 },
  { name: "July", value: 7 },
  { name: "August", value: 8 },
  { name: "September", value: 9 },
  { name: "October", value: 10 },
  { name: "November", value: 11 },
  { name: "December", value: 12 },
];

export const currentAuditType = [
  {
    label: "F2F",
    value: "F2F",
  },
  {
    label: "Self",
    value: "Self",
  },
  {
    label: "Remote",
    value: "Remote",
  },
];

export const auditCreationYear = [
  { value: "2023-2024", label: "2023-2024" },
  { value: "2024-2025", label: "2024-2025" },
  { value: "2025-2026", label: "2025-2026" },
];

export const AUDIT_STATUSES = {
  PENDING: "Pending",
  ON_HOLD: "On Hold",
  IN_PROGRESS: "In Progress",
  AUDIT_SUBMITTED: "Audit Submitted",
  RE_AUDIT_IN_PROGRESS: "Re-audit In Progress",
  RE_AUDIT_PENDING: "Re-audit pending",
  COMPLETED: "Completed",
};

export const auditStatuses = [
  { value: "Pending", label: "Pending" },
  { value: "In Progress", label: "In Progress" },
  { value: "On Hold", label: "On Hold" },
  { value: "Re-audit In Progress", label: "Re-audit In Progress" },
  { value: "Re-audit pending", label: "Re-audit Pending" },
  { value: "Audit Submitted", label: "Audit Submitted" },
  { value: "Completed", label: "Completed" },
];

export const DB_DATE_FORMAT = "YYYY-MM-DD HH:mm:ss.SSSSSSZ";

export const AUDIT_MEDIUM = {
  F2F: "F2F",
  REMOTE: "Remote",
  SELF: "Self",
};

export const OPTIONS_MAPPING = (intl) => ({
  [AUDIT_MEDIUM.F2F]: {
    [AUDIT_STATUSES.IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.continueAudit"),
        "/icons/resume.svg",
        (record, { continueAudit }) => continueAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
    [AUDIT_STATUSES.PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markOnHold"),
        "/icons/stop 1.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.startAudit"),
        "/icons/start.svg",
        (record, { startAudit }) => startAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
    ],
    [AUDIT_STATUSES.ON_HOLD]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markPending"),
        "/icons/pending_actions.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
    ],
    [AUDIT_STATUSES.AUDIT_SUBMITTED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.editAuditForm"),
        "/icons/edit.svg",
        (record, { editAudit }) => editAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markAuditCompleted"),
        "/icons/check-circle.svg",
        (record, { markAuditComplete }) => markAuditComplete(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendForReAudit"),
        "icons/reply_all.svg",
        (record, { sendForReAudit }) => sendForReAudit(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.startAudit"),
        "/icons/start.svg",
        (record, { startAudit }) => startAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.continueAudit"),
        "/icons/resume.svg",
        (record, { continueAudit }) => continueAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
    [AUDIT_STATUSES.COMPLETED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
  },
  [AUDIT_MEDIUM.REMOTE]: {
    [AUDIT_STATUSES.IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.continueAudit"),
        "/icons/resume.svg",
        (record, { continueAudit }) => continueAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
    ],
    [AUDIT_STATUSES.PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markOnHold"),
        "/icons/stop 1.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.startAudit"),
        "/icons/start.svg",
        (record, { startAudit }) => startAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
    ],
    [AUDIT_STATUSES.ON_HOLD]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markPending"),
        "/icons/pending_actions.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
    ],
    [AUDIT_STATUSES.AUDIT_SUBMITTED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.editAuditForm"),
        "/icons/edit.svg",
        (record, { editAudit }) => editAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markAuditCompleted"),
        "/icons/check-circle.svg",
        (record, { markAuditComplete }) => markAuditComplete(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendForReAudit"),
        "icons/reply_all.svg",
        (record, { sendForReAudit }) => sendForReAudit(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.startAudit"),
        "/icons/start.svg",
        (record, { startAudit }) => startAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.continueAudit"),
        "/icons/resume.svg",
        (record, { continueAudit }) => continueAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
    ],
    [AUDIT_STATUSES.COMPLETED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
  },
  [AUDIT_MEDIUM.SELF]: {
    [AUDIT_STATUSES.IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
    [AUDIT_STATUSES.PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markOnHold"),
        "/icons/stop 1.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
    ],
    [AUDIT_STATUSES.ON_HOLD]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markPending"),
        "/icons/pending_actions.svg",
        (record, { changeStatus }) => changeStatus(record)
      ),
    ],
    [AUDIT_STATUSES.AUDIT_SUBMITTED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.editAuditForm"),
        "/icons/edit.svg",
        (record, { editAudit }) => editAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.markAuditCompleted"),
        "/icons/check-circle.svg",
        (record, { markAuditComplete }) => markAuditComplete(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),

      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendForReAudit"),
        "icons/reply_all.svg",
        (record, { sendForReAudit }) => sendForReAudit(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_PENDING]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.setAuditType"),
        "/icons/reply_all.svg",
        (record, { setAuditType }) => setAuditType(record)
      ),
    ],
    [AUDIT_STATUSES.RE_AUDIT_IN_PROGRESS]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.copyLink"),
        "/icons/file_copy.svg",
        (record, { copyLink }) => copyLink(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendLinkToDNSD"),
        "/icons/share_windows.svg",
        (record, { sendLinkToDnsd }) => sendLinkToDnsd(record)
      ),
    ],
    [AUDIT_STATUSES.COMPLETED]: [
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sentReportToSD"),
        "/icons/share_windows.svg",
        (record, { sendReportToSD }) => sendReportToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.downloadReport"),
        "/icons/download.svg",
        (record, { downloadReport }) => downloadReport(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.sendAuditPdfToSD"),
        "/icons/picture_as_pdf.svg",
        (record, { sendAuditPdfToSD }) => sendAuditPdfToSD(record)
      ),
      createAction(
        getLocalizedMessage(intl, "auditListing.action.viewPreviewMode"),
        "/icons/eye.svg",
        (record, { previewAudit }) => previewAudit(record)
      ),
    ],
  },
});

export const EVALUATION_STATUS_CONSTANTS = {
  NG: "NG",
  IMPROVEMENT: "IMPROVEMENT",
  OK: "OK",
};

export const EVALUATION_STATUS_OPTIONS = [
  { value: EVALUATION_STATUS_CONSTANTS.OK, label: "OK" },
  { value: EVALUATION_STATUS_CONSTANTS.NG, label: "NG" },
  { value: EVALUATION_STATUS_CONSTANTS.IMPROVEMENT, label: "Improvement" },
];

export const RemarkOptions = [
  {
    label: "The first option OK",
    value: "1",
    associatedValue: "OK",
  },
  {
    label: "The second option NG",
    value: "2",
    associatedValue: "NG",
  },
  {
    label: "The third option IMPROVEMENT",
    value: "3",
    associatedValue: "IMPROVEMENT",
  },
];

export const INVALID_DATE = "Invalid date";
export const GRAPH_TOOLTIP = (intl) => ({
  TOTAL_AUDIT_VS_COMPLETE_AUDIT: [
    getLocalizedMessage(intl, "graph.tooltip.totalVsCompleteAudit.p1"),
    getLocalizedMessage(intl, "graph.tooltip.totalVsCompleteAudit.p2"),
  ],
  PLANNED_VS_COMPLETE_AUDIT_MONTH_VISE: [
    getLocalizedMessage(intl, "graph.tooltip.planVsCompleteAudit.monthVise.p1"),
  ],
  GRADING_GRAPH: [
    getLocalizedMessage(intl, "graph.tooltip.grading.p1"),
    getLocalizedMessage(intl, "graph.tooltip.grading.p2"),
  ],
  RADAR_GRAPH: [
    getLocalizedMessage(intl, "graph.tooltip.radar.p1"),
    getLocalizedMessage(intl, "graph.tooltip.radar.p2"),
  ],
  LEVEL2: [
    getLocalizedMessage(intl, "graph.tooltip.level2.p1"),
    getLocalizedMessage(intl, "graph.tooltip.level2.p2"),
  ],
  LEVEL3: [
    getLocalizedMessage(intl, "graph.tooltip.level3.p1"),
    getLocalizedMessage(intl, "graph.tooltip.level3.p2"),
  ],
  LEVEL4: [
    getLocalizedMessage(intl, "graph.tooltip.level4.p1"),
    getLocalizedMessage(intl, "graph.tooltip.level4.p2"),
  ],
  LEVEL5: [
    getLocalizedMessage(intl, "graph.tooltip.level5.p1"),
    getLocalizedMessage(intl, "graph.tooltip.level5.p2"),
  ],
});

export const FACING_MODE = { ENVIRONMENT: "environment", USER: "user" };
